import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDUltraRouletteMultipier implements ICommand
{

	public Number : number = 0;
	public Multipier : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Number = ba.readUint16();
		this.Multipier = ba.readUint53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.Number);
		ba.writeUint53(this.Multipier);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDUltraRouletteMultipier();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Number(W)='+this.Number+' ';
		str += 'Multipier(Q)='+this.Multipier+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'UltraRouletteMultipier';
	}

}
